/**
 * Article dates (G2, PR12, M6): short month, UTC — so the SSR text and the client re-render agree whatever
 * the visitor's time zone. The byline passes the document's defaultLanguage; the related card meta line
 * passes 'en'. An unknown language tag falls back to 'en'; an unparsable date returns null (not rendered).
 */
const DATE_OPTIONS: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' };

export function formatArticleDate(iso: string, language: string): string | null {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  try {
    return new Intl.DateTimeFormat(language, DATE_OPTIONS).format(date);
  } catch {
    return new Intl.DateTimeFormat('en', DATE_OPTIONS).format(date);
  }
}
